// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.insurance-icon[data-v-c8ec7e88] {\n  width: 85px;\n  text-align: center;\n}\n.insurance-label[data-v-c8ec7e88] {\n  font-weight: 700;\n  text-transform: uppercase;\n  color: #909194;\n  font-size: larger;\n}\n", ""]);
// Exports
module.exports = exports;
